export default __webpack_public_path__ + "static/media/Newregistration.2d2025ce.svg";